import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { CartaceoDTO } from "@app/shared/dto/anagrafe/cartaceoDTO";
import { CartaceoVO } from "@app/shared/vo/gescor/cartaceoVO";
import { ComuneDTO } from "@app/shared/dto/anagrafe/comuneDTO";

@Injectable({
    providedIn: "root"
  })
export class MapperCartaceo
  implements MapperInterface<CartaceoDTO, CartaceoVO> {
  convertVoToDto(e: CartaceoVO): CartaceoDTO {
    const cartaceoDTO = new CartaceoDTO();

    cartaceoDTO.cap = e.cap;
    cartaceoDTO.comune = new ComuneDTO();
    cartaceoDTO.comune.nome = e.comune;
    cartaceoDTO.comune.codiceIstat = e.codiceIstat;
    cartaceoDTO.dug = e.dug;
    cartaceoDTO.indirizzo = e.indirizzo;
    cartaceoDTO.nazione = e.nazione;
    cartaceoDTO.numeroCivico = e.numeroCivico;
    cartaceoDTO.esteroProvincia = e.provincia;
    cartaceoDTO.esteroCitta = e.esteroCitta;

    return cartaceoDTO || new CartaceoDTO();
  }
  convertDtoToVo(t: CartaceoDTO): CartaceoVO {
    throw new Error("Method not implemented.");
  }
  convertListVoToDto(e: CartaceoVO[]): CartaceoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: CartaceoDTO[]): CartaceoVO[] {
    throw new Error("Method not implemented.");
  }
}
